import { useCallback } from 'react';
import { active, ActiveProps } from './index';
import { $Locale, $Traffic } from '@lemon8/webapp-shared';
import { useAtomValue } from 'jotai';
import { $PageLevelTraffic } from 'shared/atoms';
import { EPageType, PageLevelTrafficUtil } from 'shared/models';

interface UsePageActiveProps {
  /** 是否是banner，用于区分discover页不同的pid */
  isBanner?: boolean;
}

export type UsePageActiveCallbackProps = Omit<ActiveProps, 'pid'>;

export const usePageActive = (props: UsePageActiveProps = {}) => {
  const { isBanner = false } = props;
  const { region } = useAtomValue($Locale);

  const { pid: trafficPid } = useAtomValue($Traffic);
  const traffic = useAtomValue($PageLevelTraffic);
  const { pageType } = traffic;
  const pageId = PageLevelTrafficUtil.getPageIdFromTraffic(traffic);

  let pid = trafficPid;
  if (pageType === EPageType.discover) {
    pid = isBanner ? 'website_seo_discover_banner' : 'website_seo_discover';
  }

  if (traffic.pageType === EPageType.article || traffic.pageType === EPageType.video) {
    pid = traffic.contentByTranslate === 1 ? `website_seo_translate_${region}` : pid;
  }

  return useCallback(
    (props: UsePageActiveCallbackProps) => {
      const { schemaOption, ampExtra } = props;

      const oneLinkAmpExtra: Record<string, string | null> = {
        traffic_type: pid,
        // current page info, not enter page
        enter_page_type: pageType,
        // current page info, not enter page
        enter_page_id: pageId,
        // related-to campaign.gid, for new user acceptance
        ...ampExtra,
      };

      // append source_group_id
      // 1. activating target page is article or video
      // 2. activating source page is article or video
      if (schemaOption.pageType === 'article' || schemaOption.pageType === 'video') {
        oneLinkAmpExtra.source_group_id = schemaOption.groupId;
      } else if (traffic.pageType === 'article' || traffic.pageType === 'video') {
        oneLinkAmpExtra.source_group_id = traffic.groupId;
      }

      active({
        pid,
        schemaOption,
        ampExtra: oneLinkAmpExtra,
      });
    },
    [pid, pageType, pageId],
  );
};
